__webpack_require__.p = "/mythic-companion/";